var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.788.644q-.66.045-1.226.465-.165.106-4.428 4.38-4.26 4.275-4.38 4.424a2 2 0 0 0-.249.49q-.095.276-.48 1.568a41 41 0 0 0-.395 1.377.9.9 0 0 0 .022.293q.036.158.095.264.063.105.183.22.12.11.224.157.106.045.241.073.135.03.246.015.113-.015 1.48-.421l1.336-.418q.282-.09.388-.135l.015-.015q.15-.077.344-.242.27-.255 1.157-1.124L9.496 8.88q4.274-4.277 4.394-4.442.195-.267.315-.553.257-.645.129-1.318a2.33 2.33 0 0 0-.608-1.187 2.38 2.38 0 0 0-1.937-.736m.45 1.26q.301.062.547.311.249.246.31.546.09.404-.09.765a.9.9 0 0 1-.144.195q-.095.102-.457.48l-.539.538-1.604-1.604.539-.539q.376-.362.48-.458a.9.9 0 0 1 .193-.142q.363-.18.766-.092M7.695 8.91q-3.3 3.3-3.369 3.34-.066.036-1.16.373-1.095.338-1.11.33t.314-1.103q.33-1.095.36-1.146.032-.055 3.346-3.384L9.39 4.006l1.589 1.604z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v15H0z"
  })))));
};
export default SvgPencil;